import NiceSelect from 'nice-select2'

import { showPopup } from './utils/popup'

// import '../styles/nice-select2.scss'

import {
  cleanCartData,
  addItemToCart,
  updateCartItem,
  checkIfItemAlreadyInCart,
  getCartData,
  removeItemFromCart,
} from './utils/cart'
import { showNotification } from './utils/notification'
import { getCookie } from './utils/fetch'
import { roundToTwo } from './utils/numbers'
import { validateEmail } from './utils/lead'

import { createPhoneMask } from './utils/masks'


const checkoutPhoneInput = document.getElementById('checkout-input-phone')
var checkoutPhoneMask = null


window.document.addEventListener('DOMContentLoaded', () => {
  checkoutPhoneMask = createPhoneMask(checkoutPhoneInput)

  const cartData = getCartData()

  if (cartData.length == 0) {
    showNoRecords()
  } else 
    reloadCheckoutRecords()

})

window.document.goToIndexPage = () => {
  window.open('/', '_self').focus()
}

function showNoRecords() {
  document.getElementById('page-checkout').style.display = 'none'
  document.getElementById('page-checkout-empty').style.display = 'block'
}

const fetchCheckourRecords = (callback) => {
  const checkoutRecordsContainer = document.getElementById('checkout-records')

  const cartData = getCartData()

  fetch('/api/v1/checkout-records/', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'X-CSRFToken': getCookie('csrftoken'),
    },
    body: JSON.stringify({
      data: cartData,
    })
  })
  .then((response) => {
    return response.json()
  })
  .then((data) => {
    if (data.status == 'ok') {
      checkoutRecordsContainer.innerHTML = data.html

      draft.total_items_count = data.total_items_count
      draft.total_cost_without_discounts = data.total_cost_without_discounts

      document.getElementById('closure-items-total-cost').innerHTML = draft.total_cost_without_discounts

      document.getElementById('draft-total-items-count').innerHTML = draft.total_items_count
      document.getElementById('draft-total-cost-without-discounts').innerHTML = draft.total_cost_without_discounts

      recalculateMoney()

      callback()
    }
    
  })
}

var draft = {
  total_items_count: 0,
  total_cost_without_discounts: 0,
  total_cost_with_discounts: 0,
  total_cost_with_discounts_and_delivery: 0,
  delivery: {
    type: null,
    title: '???',
    cost: '???',
  },
  payment: {
    type: null,
  },
  promocode: {
    code: null,
    discount_amount: null,
    // promocode_discount_amount
  },
}
const recalculateMoney = () => {
  // TODO:
  // total_cost_without_discount -> dynamic
  // total_items_count -> dynamic

  document.getElementById('closure-items-total-cost').innerHTML = draft.total_cost_without_discounts

  let total_check = draft.total_cost_without_discounts

  let discount_amount = 0
  let discount_count_total = 0
  let discount_count_value = 0

  if (draft.total_items_count > 1) {
    document.getElementById('closure-quantity-valuation').style.display = 'flex'

    if (draft.total_items_count == 2) {
      discount_amount = 0.05
    } else if (draft.total_items_count >= 3) {
      discount_amount = 0.10
    }

    if (discount_amount > 0) {
      discount_count_total = roundToTwo(total_check * (1 - discount_amount))
      discount_count_value = roundToTwo(total_check - discount_count_total)
    }

    document.getElementById('closure-discount-amount-perc').innerHTML = discount_amount * 100 + '%'
    document.getElementById('closure-discount-amount').innerHTML = discount_count_value
    document.getElementById('closure-items-total-cost-after-discount-1').innerHTML = discount_count_total
  
  } else {
    document.getElementById('closure-quantity-valuation').style.display = 'none'

    discount_count_total = draft.total_cost_without_discounts

  }

  let discount_promocode_value = 0
  if (draft.promocode.discount_amount != null) {
    document.getElementById('closure-promocode-valuation').style.display = 'flex'

    let discount_promocode_total = discount_count_total

    discount_promocode_total = roundToTwo(discount_count_total * (1 - parseInt(draft.promocode.discount_amount) / 100))
    discount_promocode_value = roundToTwo(discount_count_total - discount_promocode_total)

    document.getElementById('closure-promocode-discount-amount-perc').innerHTML = parseInt(draft.promocode.discount_amount) + '%'
    document.getElementById('closure-promocode-discount-amount').innerHTML = discount_promocode_value
    document.getElementById('closure-items-total-cost-after-discount-2').innerHTML = discount_promocode_total

    //

    document.getElementById('closure-items-total-cost-after-discount-3').innerHTML = discount_promocode_total

    draft.total_cost_with_discounts = discount_promocode_total

  } else {
    document.getElementById('closure-promocode-valuation').style.display = 'none'

    document.getElementById('closure-items-total-cost-after-discount-3').innerHTML = discount_count_total

    draft.total_cost_with_discounts = discount_count_total

  }

  let delivery_cost = draft.delivery.cost != '???' ? draft.delivery.cost : 0
  if (draft.delivery) {

    document.getElementById('draft-delivery-title').innerHTML = draft.delivery.title
    document.getElementById('draft-delivery-cost').innerHTML = draft.delivery.cost

  }

  // bottom draft block 

  document.getElementById('draft-total-cost-without-discounts').innerHTML = total_check

  document.getElementById('draft-total-discount').innerHTML = discount_promocode_value + discount_count_value
  let draftTotal = parseFloat(total_check) - (parseFloat(discount_promocode_value) + parseFloat(discount_count_value)) + parseFloat(delivery_cost)

  draft.total_cost_with_discounts_and_delivery = draftTotal

  document.getElementById('draft-total-cost-with-discounts-and-delivery').innerHTML = draftTotal

}

const reloadCheckoutRecords = () => {
  fetchCheckourRecords(() => {
    const sizesSelects = document.querySelectorAll('.size-picker__s')

    sizesSelects.forEach((el) => {
      new NiceSelect(el, {
        searchable: false
      })
    })

  })
}

window.document.sizesSelectChanged = (e) => {
  const uuid = e.currentTarget.dataset.uuid
  const size = e.currentTarget.value

  updateCartItem({
    uuid,
    size,
  })
}
window.document.countSelectChanged = (e) => {
  const uuid = e.currentTarget.dataset.uuid
  const currentPrice = e.currentTarget.dataset.price
  const count = e.currentTarget.value

  updateCartItem({
    uuid,
    count,
  })

  document.getElementById('item-total-cost-' + uuid).innerHTML = currentPrice * count

  //

  let total_items_count = 0
  let total_cost_without_discounts = 0

  const cartData = getCartData()
  cartData.forEach(el => {
    total_items_count += parseInt(el['count'])
    total_cost_without_discounts += (parseInt(document.getElementById('item-current-price-' + el['uuid']).dataset.currentPrice) * parseInt(el['count']))
  })

  draft.total_items_count = total_items_count
  draft.total_cost_without_discounts = total_cost_without_discounts

  //

  recalculateMoney()
}

//

window.document.removeItemFromCart = (e) => {
  const uuid = e.currentTarget.dataset.uuid

  const cartData = removeItemFromCart(uuid)

  if (cartData.length == 0) {
    showNoRecords()
  } else 
    reloadCheckoutRecords()
}

//

window.document.goToItemPage = (e) => {
  const url = e.currentTarget.dataset.url

  window.open(url, '_self').focus()
}

//

window.document.scrollToCheckout1stStep = () => {
  document.getElementById('block-delivery').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })

}
window.document.selectDeliveryRegion = (e, type) => {
  const cards = document.querySelectorAll('.checkout-block__delivery-cards__card')
  cards.forEach(el => el.classList.remove('checkout-block__delivery-cards__card--active'))

  e.currentTarget.classList.add('checkout-block__delivery-cards__card--active')

  if (type == 0) {
    document.getElementById('delivery-regions-0').style.display = 'flex'
    document.getElementById('delivery-regions-1').style.display = 'none'

    enablePaymentUponReceiptCard()

  } else if (type == 1) {
    document.getElementById('delivery-regions-0').style.display = 'none'
    document.getElementById('delivery-regions-1').style.display = 'flex'

    disablePaymentUponReceiptCard()
  }

  document.getElementById('input-delivery-c').style.display = 'flex'

}

const enablePaymentUponReceiptCard = () => {
  document.getElementById('payment-card-0').classList.remove('checkout-block__payment-cards__card--disabled')
}
const disablePaymentUponReceiptCard = () => {
  document.getElementById('payment-card-0').classList.add('checkout-block__payment-cards__card--disabled')
  document.getElementById('payment-card-0').classList.remove('checkout-block__payment-cards__card--active')

  document.getElementById('payment-card-icon-0').src = '/static/images/icons/coins.png'

  if (draft.payment.type == 0) {
    draft.payment.type = null
  }

}

window.document.onPaymentCardMouseEnter = (e, type) => {
  if (e.currentTarget.classList.contains('checkout-block__payment-cards__card--active')) return;

  if (type == 0) {
    document.getElementById('payment-card-icon-0').src = '/static/images/icons/coins-white.png'
  } else if (type == 1) {
    document.getElementById('payment-card-icon-1').src = '/static/images/icons/credit-white.png'
  } else if (type == 2) {
    document.getElementById('payment-card-icon-2').src = '/static/images/icons/invoice-white.png'
  }
}
window.document.onPaymentCardMouseLeave = (e, type) => {
  if (e.currentTarget.classList.contains('checkout-block__payment-cards__card--active')) return;

  if (type == 0) {
    document.getElementById('payment-card-icon-0').src = '/static/images/icons/coins.png'
  } else if (type == 1) {
    document.getElementById('payment-card-icon-1').src = '/static/images/icons/credit.png'
  } else if (type == 2) {
    document.getElementById('payment-card-icon-2').src = '/static/images/icons/invoice.png'
  }
}
window.document.selectPaymentCard = (e, type) => {

  draft.payment.type = type

  const cards = document.querySelectorAll('.checkout-block__payment-cards__card')
  cards.forEach(el => {
    el.style.width = '230px'
    el.style.height = '40px'
    el.classList.remove('checkout-block__payment-cards__card--active')
  })
  document.getElementById('payment-card-icon-0').src = '/static/images/icons/coins.png'
  document.getElementById('payment-card-icon-1').src = '/static/images/icons/credit.png'
  document.getElementById('payment-card-icon-2').src = '/static/images/icons/invoice.png'

  document.getElementById('payment-card-invoice-text').style.display = 'none'
  document.getElementById('payment-card-invoice-row').style.display = 'none'
  document.getElementById('payment-card-invoice-noti').style.display = 'none'

  e.currentTarget.classList.add('checkout-block__payment-cards__card--active')

  if (type == 0) {
    document.getElementById('payment-card-icon-0').src = '/static/images/icons/coins-white.png'
  } else if (type == 1) {
    document.getElementById('payment-card-icon-1').src = '/static/images/icons/credit-white.png'
  } else if (type == 2) {
    document.getElementById('payment-card-icon-2').src = '/static/images/icons/invoice-white.png'

    if (window.innerWidth <= 600) {
      e.currentTarget.style.width = 'auto'
    } else {
      e.currentTarget.style.width = '435px'
    }
    e.currentTarget.style.height = 'auto'

    document.getElementById('payment-card-invoice-text').style.display = 'block'
    document.getElementById('payment-card-invoice-row').style.display = 'flex'
    document.getElementById('payment-card-invoice-noti').style.display = 'block'
  }
}

//

const showPromocodeButton = (type) => { 
  if (type == 'mobile') {
    document.getElementById('promocode-button-m').style.display = 'flex' 
  } else {
    document.getElementById('promocode-button').style.display = 'flex' 
  }
}
const hidePromocodeButton = (type) => { 
  if (type == 'mobile') {
    document.getElementById('promocode-button-m').style.display = 'none'
  } else {
    document.getElementById('promocode-button').style.display = 'none'
  }
}

window.document.inputPromocodeOnChange = (e, type) => {
  const value = e.currentTarget.value

  if (value.trim() != '') {
    showPromocodeButton(type)
  } else {
    hidePromocodeButton(type)
  }
}

window.document.sendPromocode = (type) => {
  const promocodeStatusElement = document.getElementById('closure-promocode-status')
  const promocodeStatusElementMobile = document.getElementById('closure-promocode-status-m')
  
  let promocode = ''

  let promocodeWeb = document.getElementById('checkout-input-promocode').value
  let promocodeMobile = document.getElementById('checkout-input-promocode-m').value
  if (type == 'mobile') {
    promocode = promocodeMobile.trim()
  } else {
    promocode = promocodeWeb.trim()
  }

  promocodeStatusElement.innerHTML = ''
  promocodeStatusElementMobile.innerHTML = ''

  promocodeStatusElement.classList.remove('text-green')
  promocodeStatusElement.classList.remove('text-red')
  promocodeStatusElementMobile.classList.remove('text-green')
  promocodeStatusElementMobile.classList.remove('text-red')

  document.getElementById('promocode-button').style.pointerEvents = 'none'
  document.getElementById('promocode-button').style.opacity = '0.7'

  document.getElementById('promocode-button-m').style.pointerEvents = 'none'
  document.getElementById('promocode-button-m').style.opacity = '0.7'
  

  fetch('/api/v1/promocode/', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'X-CSRFToken': getCookie('csrftoken'),
    },
    body: JSON.stringify({
      promocode: promocode,
    })
  })
  .then((response) => {
    return response.json()
  })
  .then((data) => {
    if (data.status == 'ok') {
      draft.promocode.discount_amount = data.discount_amount
      draft.promocode.code = promocode

      promocodeStatusElement.innerHTML = 'промокод активирован'
      promocodeStatusElement.classList.add('text-green')
      promocodeStatusElementMobile.innerHTML = 'промокод активирован'
      promocodeStatusElementMobile.classList.add('text-green')

      document.getElementById('closure-promocode-discount-amount-perc').innerHTML = promocode.discount_amount * 100 + '%'
      document.getElementById('closure-promocode-discount-amount-perc').innerHTML = promocode.discount_amount * 100 + '%'

      recalculateMoney()

    } else {
      draft.promocode.discount_amount = null

      promocodeStatusElement.innerHTML = 'промокод недействителен'
      promocodeStatusElement.classList.add('text-red')
      promocodeStatusElementMobile.innerHTML = 'промокод недействителен'
      promocodeStatusElementMobile.classList.add('text-red')
    }

    document.getElementById('promocode-button').style.pointerEvents = 'all'
    document.getElementById('promocode-button').style.opacity = '1.0'
    document.getElementById('promocode-button-m').style.pointerEvents = 'all'
    document.getElementById('promocode-button-m').style.opacity = '1.0'

  })
  
}

//

window.document.setDeliveryType = (e, type, id) => {
  draft.delivery = {
    type: type + '-' + id,
    title: e.currentTarget.dataset.title,
    cost: e.currentTarget.dataset.cost,
  }

  recalculateMoney()

}

//

const checkoutDeliveryInput = document.getElementById('checkout-input-delivery')

const checkoutEmailInput = document.getElementById('checkout-input-email')
const checkoutNameInput = document.getElementById('checkout-input-name')
const checkoutWishesTextarea = document.getElementById('checkout-textarea-wishes')

const validateDelivery = () => {
  if (draft.delivery.type == null) return false
 
  return true
}

const validatePayment = () => {
  if (draft.payment.type == null) return false
 
  return true
}

const validateDraftInputs = (showError) => {
  let elementsWithError = []

  if (checkoutDeliveryInput.value.trim() == '') {
    if (showError) checkoutDeliveryInput.classList.add('input--error')
    elementsWithError.push(checkoutDeliveryInput)
  } else {
    checkoutDeliveryInput.classList.remove('input--error')
  }

  if (checkoutEmailInput.value.trim() == '' || !validateEmail(checkoutEmailInput.value)) {
    if (showError) checkoutEmailInput.classList.add('input--error')
    elementsWithError.push(checkoutEmailInput)
  } else {
    checkoutEmailInput.classList.remove('input--error')
  }

  if (checkoutNameInput.value.trim() == '') {
    if (showError) checkoutNameInput.classList.add('input--error')
    elementsWithError.push(checkoutNameInput)
  } else {
    checkoutNameInput.classList.remove('input--error')
  }
  
  if (checkoutPhoneInput.value.trim() == '' || (checkoutPhoneMask != null && checkoutPhoneMask.unmaskedValue.length < 11)) {
    if (showError) checkoutPhoneInput.classList.add('input--error')
    elementsWithError.push(checkoutPhoneInput)
  } else {
    checkoutPhoneInput.classList.remove('input--error')
  }

  return elementsWithError
}

window.document.draftInputOnChange = () => {
  validateDraftInputs(false)
}

window.document.sendOrder = (e) => {

  if (!validateDelivery()) {
    document.getElementById('block-delivery').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })

    showNotification({ text: 'Пожалуйста выберите способ доставки', type: 'info' })
    
    return;
  }
  if (!validatePayment()) {
    document.getElementById('block-payment').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })

    showNotification({ text: 'Пожалуйста выберите способ оплаты', type: 'info' })

    return;
  }
  const inputsWithError = validateDraftInputs(true)
  if (inputsWithError.length != 0) {
    inputsWithError[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })

    showNotification({ text: 'Пожалуйста заполните обязательные поля', type: 'info' })

    return;
  }

  const cartData = getCartData()

  if (draft.payment.type == 1) {

    fetch('/api/v1/invoice/', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRFToken': getCookie('csrftoken'),
      },
      body: JSON.stringify({
        type: 0,
        email: checkoutEmailInput.value,
        name: checkoutNameInput.value,
        phone: checkoutPhoneMask.unmaskedValue,
        wishes: checkoutWishesTextarea.value,
        cart: cartData,
        delivery_address: checkoutDeliveryInput.value,
        delivery_type: draft.delivery.type,
        payment_type: draft.payment.type,
        promocode: draft.promocode.code,
        total_items_count: draft.total_items_count,
        total_cost_without_discounts: draft.total_cost_without_discounts,
        total_cost_with_discounts: draft.total_cost_with_discounts,
        total_cost_with_discounts_and_delivery: draft.total_cost_with_discounts_and_delivery,
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status == 'ok') {
        window.location = data.formUrl
      } else if (data.status == 'error') {
        showNotification({ text: data.info, type: 'error' })
      }
    })

  } else {

    window.ym(46695258, 'reachGoal', 'goal-basket-checkout')

    window.gtag('event', 'goal-basket-checkout', {})

    window.VK.Retargeting.Event('lid_place-an-order')
    window.VK.Retargeting.ProductEvent(160310, "purchase", {"business_value" : 2500})


    fetch('/api/v1/leads/new/', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRFToken': getCookie('csrftoken'),
      },
      body: JSON.stringify({
        type: 0,
        email: checkoutEmailInput.value,
        name: checkoutNameInput.value,
        phone: checkoutPhoneMask.unmaskedValue,
        wishes: checkoutWishesTextarea.value,
        cart: cartData,
        delivery_address: checkoutDeliveryInput.value,
        delivery_type: draft.delivery.type,
        payment_type: draft.payment.type,
        promocode: draft.promocode.code,
        total_items_count: draft.total_items_count,
        total_cost_without_discounts: draft.total_cost_without_discounts,
        total_cost_with_discounts: draft.total_cost_with_discounts,
        total_cost_with_discounts_and_delivery: draft.total_cost_with_discounts_and_delivery,
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status == 'ok') {
        console.log('ok')
      }
    })

    document.getElementById('draft-btn').innerHTML = 'Мы приняли вашу заявку!'

  }

}